import React from "react"
import { BrowserRouter, Route, Routes  } from 'react-router-dom';
import Home from '../pages/home'
import Register from '../pages/register'
import RegisterConfirmation from '../pages/registerConfirmation'
import Login from '../pages/login'
import LoginDirection from '../pages/loginDirection'
import ForgetPassword from '../pages/forgetPassword'
import ResetPin from '../pages/resetPinWithParams'
import Dashboard from '../pages/dashboard'
import Profile from '../pages/profile'
import Onboarding from '../pages/onboarding'
import OnboardingThank from '../pages/onboardingThank'
import Reminders from '../pages/reminders'
import Alertness from '../pages/alertness'
import AlertnessTest from '../pages/alertnessTest'
import AlertnessTestComplete from '../pages/alertnessTestComplete'
import AlertnessTestResult from '../pages/alertnessTestResult'
import FeelAtTheMoment from '../pages/feelAtTheMoment'
import DailyAlertness from '../pages/dailyAlertness'
import SelfAssessment from '../pages/selfAssessment'
import SelfAssessmentThank from '../pages/selfAssessmentThank'
import TermsAndConditions from '../pages/termsAndConditions'
import ContactUs from '../pages/contactUs'
import NotFound from '../pages/notFound'
import ProtectedRoute from './ProtectedRoute';
import BenefitsToYou from '../pages/benefitsToYou';

// eslint-disable-next-line
const App = () => {
    return (
        <BrowserRouter basename="/">
            <Routes>
                <Route
                    path="/:cToken"
                    element={
                        <ProtectedRoute>
                            <Home />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/:cToken/register"
                    element={
                        <ProtectedRoute>
                            <Register />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/:cToken/register-confirm"
                    element={
                        <ProtectedRoute>
                            <RegisterConfirmation />
                        </ProtectedRoute>
                    }
                />
                <Route path="/:cToken/login" element={<Login/>} exact/>
                <Route path="/login" element={<Login/>} exact/>
                <Route path="/logged-in" element={<LoginDirection/>} exact/>
                <Route path="/forget-password" element={<ForgetPassword/>} exact/>
                <Route path="/reset-pin/:token" element={<ResetPin/>} exact/>
                <Route path="/change-pin" element={<ResetPin/>} exact/>
                <Route path="/dashboard" element={<Dashboard/>} exact/>
                <Route path="/profile" element={<Profile/>} exact/>
                <Route path="/onboarding-process" element={<Onboarding/>} exact/>
                <Route path="/thank-you" element={<OnboardingThank/>} exact/>
                <Route path="/reminders" element={<Reminders/>} exact/>
                <Route path="/alertness" element={<Alertness/>} exact/>
                <Route path="/alertness-test" element={<AlertnessTest/>} exact/>
                <Route path="/alertness-test-result" element={<AlertnessTestResult/>} exact/>
                <Route path="/alertness-test-complete" element={<AlertnessTestComplete/>} exact/>
                <Route path="/daily-questionnaire" element={<FeelAtTheMoment/>} exact/>
                <Route path="/daily-alertness" element={<DailyAlertness/>} exact/>
                <Route path="/self-assessment" element={<SelfAssessment/>} exact/>
                <Route path="/self-assessment-complete" element={<SelfAssessmentThank/>} exact/>
                <Route path="/terms-and-conditions/:register" element={<TermsAndConditions/>} exact/>
                <Route path="/contact-us" element={<ContactUs/>} exact/>
                <Route path="*" element={<NotFound/>} exact/>
                <Route path="/404" element={<NotFound/>} exact/>
                <Route path="/benefits" element={<BenefitsToYou/>} exact/>
            </Routes>
        </BrowserRouter>);
};

export default App;